export { stairOpeningBounds } from "game-common/room/ember/stair_geometry"
